// The visitor's GCG shop session as the cart stored it (`POST …/shops/{shopId}/sessions` → 201,
// rotated on every cart op by `X-Galleria-Session-Token`). One reader, so the cart and the telemetry
// transport (ASK-145 §18.10: telemetry is authorised by this same token) agree on what "this shop's
// session" is and when it is too near expiry to use.

export const SESSION_STORAGE_KEY = "kapowx_session";

/** The stored session for `shopId`, or null: none, another shop's, or within 60 s of expiry (the
 *  next request would 401-and-retry anyway; skipping it saves the round-trip). */
export function storedShopSession(shopId) {
	try {
		const raw = localStorage.getItem(SESSION_STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		// Only accept sessions matching the active shop — switching shops
		// invalidates any cached session for the other one.
		if (parsed?.shopId !== shopId) return null;
		if (parsed.expiresAt && new Date(parsed.expiresAt).getTime() - Date.now() < 60_000) return null;
		return parsed;
	} catch {
		return null;
	}
}
